module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/react-bootstrap/~/@babel/runtime-corejs2/core-js/array/from.js
// module id = 1710
// module chunks = 0